import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=6b86b4ab"
import script from "./ActionsMenu.vue?vue&type=script&lang=js"
export * from "./ActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports